import BaseClass from "./BaseClass";
import Util from "../util/Util";

export default class IntersectionObserverClass extends BaseClass {
    constructor(_target,_option={root:null,rootMargin:"0% 0% 0% 0%",threshold: 0}) {
        super();
        this.name = "IntersectionObserverClass";

        this._target = _target;

        this.option = {
            root: (_option.root)? _option.root : null,
            rootMargin: (_option.rootMargin)? _option.rootMargin : "0% 0% 0% 0%",
            threshold: (_option.threshold)? _option.threshold : 0
        };

        this.observer = new IntersectionObserver(this.onObserver.bind(this),this.option);
        this.isActive = false;
        this.isStart = false;
        this.isLoad = false;
    }

    onCreate() {
        this.target = (typeof this._target == "string")? $(this._target) : this._target ;
    }

    onLoad() {
        super.onLoad();
        this.isLoad = true;
    }

    onImageLoadEnd(){
        this.observer.observe(this.target.get(0));
    }

    onObserver(e){
        const event = e[0];
        if(event.isIntersecting && event.intersectionRatio >= this.option.threshold){
            if(!this.isActive){
                this.isActive = true;
                this.onActive();
            }
            if(!this.isStart){
                this.isStart = true;
                this.onStart();
            }
        } else {
            if(this.isStart){
                this.isStart = false;
                this.onStop();
            }
        }
    }

    onActive(){
        //console.log(this.name,"onActive");
    }

    onStart(){
        //console.log(this.name,"onStart");
    }

    onStop(){
        //console.log(this.name,"onStop");
    }

}